import {
    ACTIVITIES,
    AGENDA,
    COMPANIES,
    CONTACTS,
    OPPORTUNITIES,
    SALESORDERS,
    TASKS,
} from 'constants/Entities';

import ActivityModel from 'models/ActivityModel';
import AgendaModel from 'models/AgendaModel';
import CompanyModel from 'models/CompanyModel';
import ContactModel from 'models/ContactModel';
import OpportunityModel from 'models/OpportunityModel';
import SalesOrdersModel from 'models/SalesOrdersModel';
import TaskModel from 'models/TaskModel';

/**
 * Copilot data transformers by entity type
 * Maps entity types to their Model's copilot transformation methods
 * Methods are bound to preserve 'this' context when called as standalone functions
 */
export const COPILOT_TRANSFORMERS = {
    [ACTIVITIES.trueName]: ActivityModel.toCrudFromCopilot.bind(ActivityModel),
    [AGENDA.trueName]: AgendaModel.toCrudFromCopilot.bind(AgendaModel),
    [COMPANIES.trueName]: CompanyModel.toCrudFromCopilot.bind(CompanyModel),
    [CONTACTS.trueName]: ContactModel.toCrudFromCopilot.bind(ContactModel),
    [OPPORTUNITIES.trueName]: OpportunityModel.toCrudFromCopilot.bind(OpportunityModel),
    [SALESORDERS.trueName]: SalesOrdersModel.toCrudFromCopilot.bind(SalesOrdersModel),
    [TASKS.trueName]: TaskModel.toCrudFromCopilot.bind(TaskModel),
};
